import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import hashPassword from "../components/HashPassword";
import emailjs from '@emailjs/browser';
// const nodemailer = require("nodemailer");

// const transporter = nodemailer.createTransport({
//   host: "smtp.gmail.com",
//   port: 465,
//   secure: true, // Use true for port 465, false for port 587
//   auth: {
//     user: "johnvea74@gmail.com",
//     pass: "sopc frvu eckh dppn",
//   },
// });

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}





function Login() {
    const windowSize = useWindowSize();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [reseting, setReseting] = useState(false);
    const [checkVerification, setCheckVerification] = useState(false);
    const [verificationStatus, setVerificationStatus] = useState(false);
    const [varCode, setVarCode] = useState('');
    const [varCodeConf, setVarCodeConf] = useState('');
    const [name, setName] = useState(null)
    const apiKey = process.env.REACT_APP_API_KEY;
    // const [userData, setUserData] = useState(null)

    // useEffect(() => {
    //   const userDataFromStorage = localStorage.getItem("userData");
    //   if (!userDataFromStorage) return;
    //         //console.log(userDataFromStorage)
    //   const parsedData = JSON.parse(userDataFromStorage);
    //   setUserData(parsedData)
    // }, []);


    function encodePassword(password) {
        return hashPassword(btoa(password));
    }

    function verticalSpacer(height) {
        return <div style={{ height: height }}></div>;
    }

    
  const handleSubmit = async (event) => {
    event.preventDefault();
    const userData = {
      api_key: apiKey,
      user_email: email,
      user_password: encodePassword(password),
    };
    // console.log(process.env.REACT_APP_API_BASE_URL)
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/userLogin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        alert("Login failed. Please check your username or password.");
        return;
      }

      const data = await response.json();
      //console.log('Login successful:', data);
      const userDataToStore = {
        id: data.user.uid,
        email: data.user.email,
        firstName: data.user.FirstName,
        lastName: data.user.LastName,
        admin: data.user.admin,
        ShippingAddressStreet: data.user.ShippingAddressStreet,
        ShippingAddressApt: data.user.ShippingAddressApt,
        ShippingAddressCity: data.user.ShippingAddressCity,
        ShippingAddressState: data.user.ShippingAddressState,
        ShippingAddressZipCode: data.user.ShippingAddressZipCode
      };
      //console.log(userDataToStore)
      localStorage.setItem('userData', JSON.stringify(userDataToStore));
      
      navigate('/CustomerDashboardPage');

    } catch (error) {
      console.error('Error:', error);
      setError(error.message);
    }
  };

  const handleCancel = () => {
    navigate('/');
  };

async function doesEmailExist() {
    const payload = { api_key: apiKey, user_email: email };

    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/getUserFirstName`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });

        if (!response.ok) throw new Error(`Error: ${response.statusText}`);

        
        const data = await response.json();

        if (data && data.length > 0 && data[0]?.FirstName) {
            const firstName = data[0].FirstName;
            setName(firstName); 
            return true; 
        }
        
        return false; 
    } catch (error) {
        console.error("Failed to find user:", error);
        return false;
    }
}

  function isValidEmail(email) {
        //regular expression pattern for basic email validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }

    // function sendEmail(code) {
    //     const now = new Date();
    //     const tenMinutesLater = new Date(now.getTime() + 10 * 60 * 1000);
    //     // Format time 
    //     const formattedTime = tenMinutesLater.toLocaleTimeString([], {
    //         hour: '2-digit',
    //         minute: '2-digit',
    //     });

    //     emailjs.send(
    //         "service_g4gyqrh",
    //         "template_oq9nlxk",
    //         {
    //             passcode: code,
    //             time: formattedTime,
    //             email: email,
    //         },
    //         {
    //             publicKey: "EjnhASYsdI6zI-c_I",
    //         }
    //         ).then(
    //         () => console.log("SUCCESS!"), setCheckVerification(true),
    //         (error) => console.log("FAILED...", error.text)
    //     );

    // };

    function RandomStringGenerator() {
        const length = Math.floor(Math.random() * 20) + 5
        const generateRandomString = (len) => {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < len; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        };
        //   console.log(generateRandomString(length))
        return generateRandomString(length)
    }

    useEffect(() => {
        if (!varCode) return;
        const now = new Date();
        const tenMinutesLater = new Date(now.getTime() + 10 * 60 * 1000);
        // Format time 
        const formattedTime = tenMinutesLater.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
        });

        const subject = `One Time Passcode for password reset`
        const message = `To authenticate, please use the following One Time Password (OTP):

<strong style="font-size: 24px; color: #333; letter-spacing: 2px;">${varCode}</strong>

This OTP will be valid for 10 mins or untill ${formattedTime}.

Do not share this OTP with anyone. If you didn't make this request, you can safely ignore this email.
Carmel House Supply will never contact you about this email or ask for any login codes or links. Beware of phishing scams.

Thanks for visiting Carmel House Supply!`
        
        // console.log("Herererre")
        // console.log(usersName)
        const userExists = doesEmailExist()
        //console.log(userExists)
        if(userExists.result === true){
            //setName(usersName)
            sendEmail(subject, message)
            //console.log(varCode)
            setCheckVerification(true)
        }
        else{
            setReseting(false)
            alert("Email not found, please verify that you have provided the correct email address!")
        }
        
        
    }, [varCode]);


useEffect(() => {
    if (!varCode) return;
    
    const now = new Date();
    const tenMinutesLater = new Date(now.getTime() + 10 * 60 * 1000);
    
    // Format time 
    const formattedTime = tenMinutesLater.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
    });
    
    const subject = `One Time Passcode for password reset`;
    const message = `To authenticate, please use the following One Time Password (OTP):

<strong style="font-size: 24px; color: #333; letter-spacing: 2px;">${varCode}</strong>

This OTP will be valid for 10 mins or until ${formattedTime}.

Do not share this OTP with anyone. If you didn't make this request, you can safely ignore this email.

Carmel House Supply will never contact you about this email or ask for any login codes or links. Beware of phishing scams.

Thanks for visiting Carmel House Supply!`;
    
    if (name != null && name.length > 0 && !reseting) {
        //console.log(email)
        sendEmail(subject, message);
        //console.log(varCode)
        setCheckVerification(true);
        setReseting(true)
    }
}, [name, varCode, reseting]);


  const handlePasswordReset = () => {
    if (!email) {
      alert("Please enter your email address to reset your password.");
      return;
    }
    if (!isValidEmail(email)) {
        alert("Please enter a valid email address!");
        return;
    }
    
    const code = RandomStringGenerator();
    
    setVarCode(code);
    setReseting(true)

  };

  function handleCheckVerificationCode(){
    if (varCodeConf === varCode) {
        setVerificationStatus(true)
        setCheckVerification(false)
    }
    else{
        alert("Verification Failed! please check email for verification code");
    }
  }

  
  // let the user know that their password have been reset 
  function sendEmail( subject, message){
    
    const payload = {
            api_key: apiKey,
            user_email: email,
            subject: subject, //"Password Reset Confirmation",
            message: message
            
        };

            try {
                fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/sendEmail`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`Error: ${response.statusText}`);
                    }
                    return response.json();
                })
                .then((data) => {
                    //console.log(data);
                    //alert("Password Reset successful! You can now log in.");
                    // navigate('/CustomerDashboardPage');
                })
                .catch((error) => {
                    console.error("email sent failed:", error);
                    //alert("email sent failed, please try again.");
                });
            } catch (error) {
                console.error("email sent failed:", error);
                //alert("email sent, please try again.");
            }

  }


  function horizontalSpacer(width) {
    return <div style={{ display: "inline-block", width: width }}></div>;
    }

    function handleResetingPassword(){
        if (password !== confirmPassword) {
            alert("Passwords do not match!");
            return;
        }

        if (password.length < 4) {
            alert("Password must be at least 4 characters long!");
            return;
        }

        if (!isValidEmail(email)) {
            alert("Please enter a valid email address!");
            return;
        }


        const payload = {
            api_key: apiKey,
            user_email: email,
            user_password: encodePassword(password)
        };

            try {
                fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/resetPassword`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`Error: ${response.statusText}`);
                    }
                    return response.json();
                })
                .then((data) => {
                    console.log("password reset successful:", data);
                    
                    const subject = "Password Reset Confirmation"
                    const message = `Hello, ${name}

Your password has been successfully reset.

If you did not request this change, please contact our support team immediately.

You can now log in with your new password.

Thank you,
The Carmel House Supply Team`
                    sendEmail(subject, message)
                    alert("Password Reset successful! You can now log in.");
                    navigate('/CustomerDashboardPage');
                })
                .catch((error) => {
                    console.error("Password Reset failed:", error);
                    alert("Password Reset failed, please try again.");
                });
            } catch (error) {
                console.error("Password Reset failed:", error);
                alert("Password Reset, please try again.");
            }
    }
  return (
    <div>
    <div className="logincontainer" align="center">
      {!reseting && (
        <h1 className="loginTitle">Login</h1>
      )}
      {checkVerification && !verificationStatus && (
        <h1 className="loginTitle">Please Enter OTP Sent to {email}</h1>
      )}
      {verificationStatus && (
        <h1 className="loginTitle">Please Enter New Password</h1>
      )}

      <br />
      {!reseting ? (
      <div className="login-page">
        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center' }}>
            {/* <label htmlFor="email">Email</label> */}
            <input
                placeholder="Email"
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {/* {horizontalSpacer(20)} */}
            {/* <label htmlFor="password">Password </label> */}
            <input
            placeholder="Password"
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p style={{ color: 'red' }}>{error}</p>}
            <div className='loginButtonContainer' style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center' }}>
            <button className="loginsubmitbutton" type="submit" onClick={handleSubmit}>Login</button>
            {/* {horizontalSpacer(40)} */}
            <button className="forgetPasswordButton" type="button" onClick={handlePasswordReset}>Reset Password</button>
          </div>
          <button className="cancelloginbutton" style={{
                padding: "8px 16px",
                borderRadius: 6,
                border: "1px solid #686666",
                background: "rgb(248, 198, 149)",
                cursor: "pointer",
                marginRight: 8,
                color: "#000000ff"
              }}type="button" onClick={()=>window.location.href = '/signup'}>Sign Up</button>
          <button className="cancelloginbutton" type="button" onClick={handleCancel}>Cancel</button>
          
        </form>
      </div>
      ): <div>
        {checkVerification && (
        <div>
            <label>
            {/* Verification Code:
            {horizontalSpacer(10)} */}
            <input
            style={{
                width: '46%',
                fontSize: '18px',
                marginBottom: '2%',
            }}
                placeholder="Verification Code"
                type="text"
                value={varCodeConf}
                onChange={(e) => setVarCodeConf(e.target.value)}
                required
            />
            </label>
            <div className='loginButtonContainer' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <button className="loginsubmitbutton" type="submit" onClick={handleCheckVerificationCode}>submit</button>
            {/* {horizontalSpacer(10)} */}
            <button type="button" style={{
                width: '50%',
                marginBottom: '2%',
                padding: '10px',
                fontSize: '16px',
                backgroundColor: '#ff0000e9',
                color: '#000000',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                transition: 'background-color 0.3s ease'
            }} onClick={handleCancel}>Cancel</button>
          </div>
          
        </div>
        )}

        {verificationStatus && (
            <div>
                {horizontalSpacer(20)}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {/* <label htmlFor="password">Password </label> */}
            {/* {horizontalSpacer(40)} */}
            <input
                placeholder="Password"
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '41%'

              }}
            />
            {horizontalSpacer(10)}
            
            {/* <label htmlFor="password"> Confirm Password </label> */}
            <input
            placeholder="Confirm Password"
              type="password"
              id="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              style={{
                width: '42%'
              }}
            />
            </div>
                <div className='loginButtonContainer' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <button className="loginsubmitbutton" style={{
                    width: '45%'}} type="submit" onClick={handleResetingPassword}>submit</button> 
                {horizontalSpacer(10)}
                <button type="button" style={{
                    width: '45%',
                    marginBottom: '2%',
                    padding: '10px',
                    fontSize: '16px',
                    backgroundColor: '#ff0000e9',
                    color: '#000000',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                    transition: 'background-color 0.3s ease'
                }} onClick={handleCancel}>Cancel</button>
            </div>
            </div>
        )}

      </div>
    }
    </div>
    {verticalSpacer((windowSize.width * 0.35) + (windowSize.height * 0.2))}
    </div>
  );
}

export default Login;